import { useEffect } from 'react';
import { FeatureLayer } from '../constructors';

export function useFeatureLayerVisibility({
    featureLayer,
    isVisible,
}: {
    isVisible: boolean;
    featureLayer?: FeatureLayer;
}) {
    useEffect(() => {
        if (featureLayer) {
            featureLayer.visible = isVisible;
        }
    }, [featureLayer, isVisible]);
}
